module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function isStyleProps(styleArgument) {
    if (typeof styleArgument === 'object' && !Array.isArray(styleArgument)) {
        return styleArgument.hasOwnProperty('style') && styleArgument.hasOwnProperty('className');
    }
    return false;
}
var reduce = function (acc, style) {
    if (typeof style === 'string') {
        acc.className += acc.className.length === 0
            ? style
            : " " + style;
    }
    else if (typeof style === 'object') {
        if (isStyleProps(style)) {
            acc.className += acc.className.length === 0
                ? style.className
                : " " + style.className;
            Object.assign(acc.style, style.style);
        }
        else if (Array.isArray(style)) {
            return style.reduce(reduce, acc);
        }
        else {
            Object.assign(acc.style, style);
        }
    }
    return acc;
};
function mergeStyles() {
    var styles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styles[_i] = arguments[_i];
    }
    return styles.reduce(reduce, { style: {}, className: '' });
}
exports.mergeStyles = mergeStyles;


/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Get array of stars fill percentage
 * example: [1, 1, 0.5, 0, 0]
 */
function getUnits(count, value, isPercentage) {
    var units = [];
    if (isPercentage) {
        var oneUnitWeight = 1 / count;
        var weight = 0;
        for (var i = 0; i < count; i++) {
            var unitValue = (value - weight) / oneUnitWeight;
            if (unitValue < 0) {
                unitValue = 0;
            }
            if (unitValue > 1) {
                unitValue = 1;
            }
            weight += oneUnitWeight;
            units.push(unitValue);
        }
        return units;
    }
    // value is selected stars count
    for (var i = 0; i < count; i++) {
        var unitValue = i <= value ? 1 : 0;
        units.push(unitValue);
    }
    return units;
}
exports.getUnits = getUnits;
function getRatingValue(count, value, isPercentage) {
    var units = getUnits(count, value, isPercentage);
    return units.reduce(function (currentValue, sum) { return sum += currentValue; }, 0);
}
exports.getRatingValue = getRatingValue;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var style_1 = __webpack_require__(1);
var React = __webpack_require__(2);
var styles = __webpack_require__(7);
exports.StarTheme = {
    Filled: 'filled',
    Hollow: 'hollow',
};
var Star = /** @class */ (function (_super) {
    tslib_1.__extends(Star, _super);
    function Star() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            var _a = _this.props, onClick = _a.onClick, index = _a.index;
            if (onClick) {
                onClick(index);
            }
        };
        _this.handleMouseOver = function () {
            var _a = _this.props, index = _a.index, onMouseOver = _a.onMouseOver;
            if (onMouseOver) {
                onMouseOver(index);
            }
        };
        return _this;
    }
    Star.prototype.render = function () {
        var _a = this.props, className = _a.className, index = _a.index, onClick = _a.onClick, theme = _a.theme, uniqueKey = _a.uniqueKey, value = _a.value;
        var gradientId = "gradient-" + uniqueKey + "-" + index;
        var strokeFill = theme === exports.StarTheme.Filled ? "url(#" + gradientId + ")" : '#ff9d00';
        var offset = value * 100 + "%";
        return (React.createElement("li", tslib_1.__assign({}, style_1.mergeStyles([
            styles['container'],
            onClick && styles['pointer'],
            className,
        ]), { onClick: onClick ? this.handleClick : undefined, onMouseOver: this.handleMouseOver }),
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 18" },
                React.createElement("defs", null,
                    React.createElement("linearGradient", { id: gradientId, y2: "0%", x2: "100%", y1: "0%", x1: "0%" },
                        React.createElement("stop", { offset: "0%", stopOpacity: "1", stopColor: "#ff9d00" }),
                        React.createElement("stop", { offset: offset, stopOpacity: "1", stopColor: "#ff9d00" }),
                        React.createElement("stop", { offset: offset, stopOpacity: "0", stopColor: "#ff9d00" }),
                        theme === exports.StarTheme.Filled &&
                            React.createElement("stop", { offset: offset, stopOpacity: "1", stopColor: "#c9c9c9" }),
                        theme === exports.StarTheme.Filled &&
                            React.createElement("stop", { offset: "100%", stopOpacity: "1", stopColor: "#c9c9c9" }))),
                React.createElement("path", { stroke: strokeFill, fill: "url(#" + gradientId + ")", d: "M15.214 17.176l-.996-5.805 4.218-4.112-5.83-.847L10 1.13 7.393 6.412l-5.83.847 4.219 4.112-.996 5.805L10 14.436l5.214 2.74z" }))));
    };
    Star.defaultProps = {
        theme: exports.StarTheme.Filled,
    };
    return Star;
}(React.PureComponent));
exports.Star = Star;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var list_1 = __webpack_require__(6);
exports.Stars = list_1.Stars;
var star_1 = __webpack_require__(4);
exports.StarTheme = star_1.StarTheme;
var utils_1 = __webpack_require__(3);
exports.getRatingValue = utils_1.getRatingValue;
exports.getUnits = utils_1.getUnits;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var style_js_1 = __webpack_require__(1);
var React = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
var star_1 = __webpack_require__(4);
var styles = __webpack_require__(8);
var Stars = /** @class */ (function (_super) {
    tslib_1.__extends(Stars, _super);
    function Stars() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeIndex: undefined,
        };
        _this.onMouseLeave = function () {
            _this.setState({
                activeIndex: undefined,
            });
        };
        _this.onUnitMouseOver = function (unitIndex) {
            if (!_this.props.onClick) {
                return;
            }
            _this.setState({
                activeIndex: unitIndex,
            });
        };
        return _this;
    }
    Stars.prototype.render = function () {
        var _this = this;
        var units = utils_1.getUnits(this.getCount(), this.getValue(), this.props.percentage);
        return (React.createElement("ul", tslib_1.__assign({}, style_js_1.mergeStyles([
            styles['container'],
            this.props.containerClassName,
        ]), { onMouseLeave: this.onMouseLeave }), units.map(function (value, index) {
            return React.createElement(star_1.Star, { className: _this.props.unitClassName, index: index, key: _this.props.uniqueKey + "-" + index, onClick: _this.props.onClick, onMouseOver: _this.onUnitMouseOver, theme: _this.props.theme, uniqueKey: _this.props.uniqueKey, value: value });
        })));
    };
    Stars.prototype.getCount = function () {
        var count = this.props.count;
        if (!count || count < 0) {
            return 5;
        }
        return count;
    };
    Stars.prototype.getValue = function () {
        var _a = this.props, percentage = _a.percentage, value = _a.value;
        var activeIndex = this.state.activeIndex;
        if (typeof activeIndex !== 'undefined' && activeIndex >= 0) {
            return activeIndex;
        }
        if (percentage) {
            if (value < 0 || value > 1) {
                return 0;
            }
            return value;
        }
        if (value < 0) {
            return 0;
        }
        return value - 1;
    };
    return Stars;
}(React.PureComponent));
exports.Stars = Stars;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"stars_component-container-9DnVqhx5jqk","pointer":"stars_component-pointer-5XWxSdIRoWE"};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"stars_component-container-jpfozuzrCoq"};

/***/ })
/******/ ]);
//# sourceMappingURL=frontend-stars-component.js.map